module.exports = __webpack_public_path__ + "img/features-bg_3.9649c94f.png";